import React, { Component } from 'react';
import voiceStore from '../../stores/voiceStore';
import { observer } from 'mobx-react';
import { FaTimes } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

const withNavigation = (WrappedComponent) => {
  return (props) => {
    const navigate = useNavigate();
    return <WrappedComponent {...props} navigate={navigate} />;
  };
};

const SearchByNameModal = observer(class SearchByNameModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedNames: ''
    };
  }

  handleNameChange = (event) => {
    this.setState({ selectedNames: event.target.value });
  };

  handleSearch = async () => {
    const { selectedNames } = this.state;
    const payload = {
      ...(selectedNames && selectedNames.trim() && { talentName: selectedNames.split(',').map(name => name.trim()) }),
    };

    const result = await voiceStore.searchVoice(payload);
    if (result) {
      this.props.navigate('/search-results');
    } else {
      console.error('Error =>', result);
    }
  };

  handleOverlayClick = (event) => {
    if (event.target === event.currentTarget) {
      this.props.closeModal();
    }
  };

  componentDidMount() {
    document.addEventListener('keydown', this.handleKeyDown);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.handleKeyDown);
  }

  handleKeyDown = (event) => {
    if (event.key === 'Escape') {
      this.props.closeModal();
    }
  };

  render() {
    return (
      <div onClick={this.handleOverlayClick} className="fixed inset-0 flex flex-1 w-full items-center overflow-y-scroll lg:overflow-hidden justify-center bg-black bg-opacity-50 z-10">
        <div className="lg:fixed h-full lg:h-auto flex flex-col w-full lg:w-[40%] bg-white p-6 rounded-lg shadow-lg pt-24 lg:pt-0">
          <h2 className="font-bold text-3xl text-[#21272A] mb-4 pt-6">{`Search By Name`}</h2>
          <span className="font-normal text-base text-[#21272A]"></span>
          <FaTimes onClick={this.props.closeModal} className='absolute right-5 top-5 hover:cursor-pointer' size={20} color='black'></FaTimes>
          <div className="flex lg:flex-1 flex-col lg:flex-row w-full gap-3 mt-14">
            <div className="flex flex-col lg:flex-1">
              <span className="font-semibold text-base text-[#21272A] mb-2">Name</span>
              <div>
                <input
                  type="text"
                  placeholder="Enter names separated by commas"
                  value={this.state.selectedNames}
                  onChange={this.handleNameChange}
                  className="w-full p-2 border border-gray-300 rounded-md"
                />
              </div>
            </div>
          </div>

          <div className="mt-24 flex justify-end gap-2">
            <button
              className="text-white font-medium text-base px-6 py-2 rounded-md bg-[#130D0D]"
              onClick={this.handleSearch}
            >
              Search
            </button>
          </div>
        </div>
      </div>
    );
  }
});

export default withNavigation(SearchByNameModal);
